import styled from "styled-components";
import { getTypographyStyles } from "@security-watchdog/sw-ui-kit";

export const Timer = styled.div`
  ${getTypographyStyles({ variant: "body-highlight" })};
  display: flex;
  justify-content: center;
`;
